import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import CondicionPago from './CondicionPago';
import ACCESS from '../../../ACCESS.js';

class CondicionesPagos extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'condicion-pago/filter', deleteUrl: 'condicion-pago/delete', deleteField: 'condicion_nombre', modUrl: '/Catalogo/CondicionPago' },
      TableOp.Table('Condiciones de Pago', [
        { label: 'Clave', id: 'condicion' },
        { label: 'Descripcion', id: 'condicion_nombre' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_CONDICIONES_DE_PAGO.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_CONDICIONES_DE_PAGO.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <CondicionPago   onSave={() => {this.table()}}></CondicionPago>
        }
        {
           
          <this.TableRender   />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(CondicionesPagos)